import { FileItem } from '../../redux/common/definitions';
import { ProjectScheduleData } from '../../redux/project/definitions';
import { apiBaseUrl, apiCall, apiCallBlob, APIValidationError, Result, validatedApiCall } from '../api';

const baseURL = apiBaseUrl;

export const getProjectSchedulesFromApi = async (project_id: number): Promise<ProjectScheduleData[]> => {
  const init = {
    method: 'GET',
    auth: true,
  };

  const { data } = await apiCall<{ data: ProjectScheduleData[] }>(
    `${baseURL}/projects/${project_id}/project_schedules`,
    init,
  );
  return data;
};

export const updateProjectSchedulesFromApi = async (
  project_id: number,
  schedules: ProjectScheduleData[],
): Promise<boolean> => {
  const init = {
    method: 'PUT',
    auth: true,
    body: JSON.stringify({ schedules }),
  };

  const { data } = await apiCall<{ data: string }>(`${baseURL}/projects/${project_id}/project_schedules`, init);
  return data === 'OK';
};

export const createProjectScheduleFromApi = async (
  schedule: ProjectScheduleData,
): Promise<Result<{ data: string }, APIValidationError>> => {
  const init = {
    method: 'POST',
    auth: true,
    body: JSON.stringify(schedule),
  };

  return validatedApiCall<{ data: string }>(`${baseURL}/project_schedules`, init);
};

export const updateProjectScheduleFromApi = async (
  schedule: ProjectScheduleData,
): Promise<Result<{ data: string }, APIValidationError>> => {
  const init = {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(schedule),
  };
  return validatedApiCall<{ data: string }>(`${baseURL}/project_schedules/${schedule.id}`, init);
};

export const deleteProjectScheduleFromApi = async (id: number): Promise<boolean> => {
  const init = {
    method: 'DELETE',
    auth: true,
  };

  const { data } = await apiCall<{ data: string }>(`${baseURL}/project_schedules/${id}`, init);
  return data === 'OK';
};

export const uploadPhoneFollowUpDocument = async (file: File): Promise<FileItem> => {
  const dataForm = new FormData();
  dataForm.append('document', file, file.name);
  const init = {
    method: 'POST',
    auth: true,
    body: dataForm,
    defaultContentType: true,
  };
  const { data } = await apiCall<{ data: FileItem }>(`${baseURL}/project_schedule/file`, init);

  return data;
};

export const deletePhoneFollowUpDocument = async (file_id: number): Promise<string> => {
  const init = {
    method: 'DELETE',
    auth: true,
  };
  const { data } = await apiCall<{
    data: string;
  }>(`${baseURL}/project_schedule/file/${file_id}`, init);
  return data;
};

export const downloadPhoneFollowUpDocument = async (file_id: number): Promise<Blob> => {
  const init = {
    method: 'GET',
    auth: true,
  };
  return apiCallBlob(`${baseURL}/project_schedule/file/${file_id}`, init);
};
